var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.999 4.8807L26.998 16.8797V25.293C26.998 26.0886 26.6819 26.8516 26.1194 27.4141C25.5568 27.9767 24.7938 28.2927 23.9982 28.2927H5.99975C5.20416 28.2927 4.44117 27.9767 3.87861 27.4141C3.31604 26.8516 3 26.0886 3 25.293V16.8797L14.999 4.8807ZM24.9981 3.29484V10.2942L20.9985 6.29458V3.29484C20.9985 3.02964 21.1038 2.77531 21.2914 2.58779C21.4789 2.40027 21.7332 2.29492 21.9984 2.29492H23.9982C24.2634 2.29492 24.5178 2.40027 24.7053 2.58779C24.8928 2.77531 24.9981 3.02964 24.9981 3.29484Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5861 1.29451C13.9611 0.919597 14.4697 0.708984 15 0.708984C15.5303 0.708984 16.0389 0.919597 16.4139 1.29451L29.7068 14.5854C29.8945 14.7731 30 15.0278 30 15.2933C30 15.5589 29.8945 15.8135 29.7068 16.0013C29.519 16.189 29.2644 16.2945 28.9988 16.2945C28.7333 16.2945 28.4786 16.189 28.2909 16.0013L15 2.70839L1.70912 16.0013C1.52136 16.189 1.26671 16.2945 1.00118 16.2945C0.73565 16.2945 0.480996 16.189 0.293239 16.0013C0.105481 15.8135 0 15.5589 0 15.2933C0 15.0278 0.105481 14.7731 0.293239 14.5854L13.5861 1.29451Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.8d66990aaa568f0e7db6ffd6085ed405.svg";
export { ForwardRef as ReactComponent };